































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import { uniqBy } from "lodash";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";

@Component({ components: { CustomTableCol, CustomTableItem, CustomTable } })
export default class LearningResourceTable extends Vue {
  @Prop() users!: Array<IUser>;
  @Prop() searchUsersByEmail!: string;

  checkedUsers: Array<string> = [];
  checkboxForSelectAll: boolean = false;

  @Watch("checkedUsers")
  checkCheckedUsers() {
    this.checkboxForSelectAll = this.checkedUsers.length === this.users.length;

    this.$emit("checkedUsers", this.checkedUsers);
  }

  get screenWidth() {
    return window.innerWidth;
  }

  linkToStudent(user: any) {
    const userProfile = {
      name: "userProfileView",
      params: { id: user.id }
    };

    const studentProfile = {
      name: "student",
      params: { id: user.id }
    };

    return user?.metadata ? studentProfile : userProfile;
  }

  get showedUsers() {
    if (this.users) {
      if (this.limitedUsers.length > 0) {
        return this.limitedUsers;
      } else {
        return this.users;
      }
    } else {
      return undefined;
    }
  }

  get limitedUsers() {
    let users: Array<IUser> = [];
    let email = this.users.filter(el =>
      el.email
        ?.toLocaleLowerCase()
        .includes(this.searchUsersByEmail?.toLocaleLowerCase())
    );

    let name = this.users.filter(el =>
      el.fullName
        ?.toLocaleLowerCase()
        .includes(this.searchUsersByEmail?.toLocaleLowerCase())
    );

    users = uniqBy([...email, ...name], "id");

    return users;
  }

  selectAllListeners() {
    if (!this.checkboxForSelectAll) {
      this.checkedUsers = [];
    } else {
      this.checkedUsers = this.users.map(item => {
        return item.id;
      });
    }
  }

  checkedUser(id: string) {
    return this.checkedUsers.includes(id);
  }

  setupUser(id: string) {
    this.checkedUsers.includes(id)
      ? (this.checkedUsers = this.checkedUsers.filter(el => {
          return el !== id;
        }))
      : this.checkedUsers.push(id);
  }
}
